import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.table = this.element.querySelector("table")
    this.thead = this.table?.querySelector("thead")
    this.pageScroller = this.element.closest("main")
    if (!this.table || !this.thead || !this.pageScroller) return

    this.update = this.update.bind(this)
    this.buildOverlay()
    this.pageScroller.addEventListener("scroll", this.update)
    this.element.addEventListener("scroll", this.update)
    this.table.addEventListener("timeline:column-resize", this.update)
    window.addEventListener("resize", this.update)
    this.resizeObserver = new ResizeObserver(this.update)
    this.resizeObserver.observe(this.table)
    this.update()
  }

  disconnect() {
    this.pageScroller?.removeEventListener("scroll", this.update)
    this.element.removeEventListener("scroll", this.update)
    this.table?.removeEventListener("timeline:column-resize", this.update)
    window.removeEventListener("resize", this.update)
    this.resizeObserver?.disconnect()
    this.overlay?.remove()
  }

  buildOverlay() {
    this.overlay = document.createElement("div")
    this.overlay.setAttribute("aria-hidden", "true")
    this.overlay.style.cssText = "display:none; position:fixed; overflow:hidden; pointer-events:none; z-index:60"

    this.cloneTable = this.table.cloneNode(false)
    this.cloneTable.style.cssText = this.table.getAttribute("style") || ""
    this.cloneThead = this.thead.cloneNode(true)
    this.cloneThead.querySelectorAll("[data-controller], [data-action], [id]").forEach((element) => {
      element.removeAttribute("data-controller")
      element.removeAttribute("data-action")
      element.removeAttribute("id")
    })

    this.cloneTable.append(this.cloneThead)
    this.overlay.append(this.cloneTable)
    document.body.append(this.overlay)
    this.firstHeaderCell = this.cloneThead.querySelector("th[rowspan]")
  }

  update() {
    if (!this.overlay) return

    const scrollRect = this.element.getBoundingClientRect()
    const pageRect = this.pageScroller.getBoundingClientRect()
    const headerHeight = this.thead.getBoundingClientRect().height
    const showHeader = scrollRect.top <= pageRect.top && scrollRect.bottom > pageRect.top + headerHeight

    this.overlay.style.display = showHeader ? "block" : "none"
    if (!showHeader) return

    this.overlay.style.top = `${pageRect.top}px`
    this.overlay.style.left = `${scrollRect.left}px`
    this.overlay.style.width = `${this.element.clientWidth}px`
    this.overlay.style.height = `${headerHeight}px`
    this.cloneTable.style.width = `${this.table.getBoundingClientRect().width}px`
    this.cloneTable.style.setProperty(
      "--category-col-width",
      getComputedStyle(this.table).getPropertyValue("--category-col-width")
    )
    this.cloneTable.style.transform = `translateX(-${this.element.scrollLeft}px)`

    if (this.firstHeaderCell) {
      const sourceHeaderCell = this.thead.querySelector("th[rowspan]")
      const categoryWidth = sourceHeaderCell?.getBoundingClientRect().width

      if (categoryWidth) {
        this.firstHeaderCell.style.width = `${categoryWidth}px`
        this.firstHeaderCell.style.minWidth = `${categoryWidth}px`
        this.firstHeaderCell.style.maxWidth = `${categoryWidth}px`
      }

      this.firstHeaderCell.style.transform = `translateX(${this.element.scrollLeft}px)`
    }
  }
}
